export default __webpack_public_path__ + "static/media/trustero_logo_full.7a8a684a.svg";